import { makeStyles, Theme, Typography } from '@freighthub/silhouette-core'
import moment from 'moment'
import { FC } from 'react'
import { DateFormatMoment } from 'utils/date'

const ownStyles = makeStyles<Theme>((theme) => ({
  footerText: {
    margin: theme.spacing(0.5, 1, 0),
  },
}))

interface IMessageFooterProps {
  messageDate: Date
}

export const MessageFooter: FC<IMessageFooterProps> = ({ messageDate }) => {
  const classes = ownStyles()
  return (
    <Typography variant="caption" color="textSecondary" className={classes.footerText} component="div">
      {moment(messageDate).format(DateFormatMoment.TIME)}
    </Typography>
  )
}
